import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import queryString from 'query-string';
import { getPartnerApisHeaders } from "./partnerApisHeaders";

/* Get Feedback details for a given Partner */
export const getFeedbackDetails = (mpacBaseUrl, partnerId, queryParams) => fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/reporting/feedback/details?").concat(queryString.stringify(queryParams)), {
  headers: getPartnerApisHeaders()
}).then(response => response.json());
/* Gets feedback reports for a partner */

export const getFeedbacksReports = (mpacBaseUrl, partnerId, queryParams = {}, metric) => {
  return fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/reporting/feedback/metrics/").concat(metric, "?").concat(queryString.stringify(queryParams)), {
    headers: getPartnerApisHeaders()
  }).then(response => response.json());
};